import { optionsToStrategy } from '@/common/utils/optionsToStrategy';

export const options = [
  { label: 'Nenhum', value: 'by_none' },
  { label: 'Por produto', value: 'by_product' },
  { label: 'Por serviço', value: 'by_product_category' },
];

export const strategy = optionsToStrategy(options);
